import { type FunctionComponent } from 'react';
import { type EmailOriginationEnum } from '../../__generated__/graphql-client-types';
import { useNewsletterSignUp } from '../../hooks/newsletter/newsletter.hooks';
import { StyledButton } from '../buttons';
import { Recaptcha } from '../common-components/recaptcha/recaptcha.component';
import { TextInput } from '../inputs/input/text-input/text-input.component';
import { InputGroup } from '../inputs/input-group/input-group.component';
import AlertOctagonIcon from '../svgs/untitled-ui/alert-octagon.svg';

export type EmailSignUpFormProps = {
	origin?: EmailOriginationEnum;
	heading?: string;
	description?: string;
	buttonStyle?: 'PRIMARY' | 'SECONDARY';
	inputIcon?: JSX.Element;
};

export const EmailSignUpForm: FunctionComponent<EmailSignUpFormProps> = ({
	origin,
	heading = 'Sign up to receive design ideas and product updates',
	description,
	buttonStyle = 'PRIMARY',
	inputIcon
}) => {
	const { emailRegistration, onSubmit, error } = useNewsletterSignUp(origin);

	return (
		<div>
			<h2 className="font-medium db f5 mt0 mb2">{heading}</h2>
			{description && <p className="m-0 mb-4">{description}</p>}
			<form onSubmit={onSubmit} className="flex flex-column" aria-label="newsletter signup form">
				<InputGroup className="w-100">
					<TextInput
						ariaLabel="email"
						placeholder="Enter Email Address"
						autoCapitalize={'off'}
						icon={inputIcon}
						{...emailRegistration}
					/>
					<StyledButton buttonType="submit" automationHook={'email-sign-up'} buttonStyle={buttonStyle}>
						Subscribe
					</StyledButton>
				</InputGroup>
				{/* Input Group doesn't support form invalid state */}
				{error && (
					<div className={`flex flex-row items-center mt3 f6 theme-error gc1`} data-automation={'email-sign-up-error'}>
						<AlertOctagonIcon className="f5 minw1" />
						{error.message}
					</div>
				)}
				<Recaptcha />
			</form>
		</div>
	);
};
